import Crypto from "crypto-js";
import { keyCrypto } from 'config/AppConfig'
import parse from 'html-react-parser';
import Moment from 'moment';
import { useLocation } from "react-router";


//#region Function
export const IsNullOrUndefined = (Value: any) => {
    let Result = true;
    if (Value) {
        Result = false;
    }
    return Result;
};
export const undefinedOrNull = (value, mode?: "string" | "number" | "bool" | "dateToString", format = "DD/MM/YYYY") => {
    if (mode == "string") {
        return value != undefined && value != null ? value + "" : "";
    }
    else if (mode == "number") {
        return value != undefined && value != null && value != "" ? (+((value + "").replace(",", ""))) : null;
    } else if (mode == "bool") {
        let res = false;
        if (value != undefined && value != null && value != "") {
            if ((value + "").toLowerCase() == "true") {
                res = true;
            }
        }
        return res;
    } else if (mode == "dateToString") {
        let res = null;
        if (value != undefined && value != null && value != "") {

            res = DateTimeToString(value, format);
        }
        return res;
    }
    else {
        return value != undefined ? value : null;
    }
}
export const ToInt = (Value: string) => {
    let Result = 0;
    if (Value) {
        Result = parseInt(Value);
    }
    return Result;
};
/**
 * แปลง string เป็น html
 * @param val 
 * @returns Tag html
 */
export const ParseHtml = (val: string) => {
    if (val)
        return parse(val);
    else
        return val;
}
/**
 * แปรง Date เป็น String
 * @param value 
 * @param format 
 * @returns Date string
 */
export const DateTimeToString = (value, format = "DD/MM/YYYY") => {
    Moment.locale('th');
    return Moment(value).format(format)
};
//#endregion

//#region Crypto
export const Encrypt = (dataEncrypt: any) => {
    let data = dataEncrypt.toString();
    let result = Crypto.AES.encrypt(data, keyCrypto).toString();
    result = result.replace(/\//g, "s14sh").replace(/\+/g, "p1u5");

    return result;
};
export const Decrypt = (dataDecrypt: any) => {
    if (dataDecrypt && dataDecrypt != null && dataDecrypt !== "null") {
        dataDecrypt = dataDecrypt.replace(/s14sh/g, "/").replace(/p1u5/g, "+");
        let bytes = Crypto.AES.decrypt(dataDecrypt, keyCrypto);
        let result = bytes.toString(Crypto.enc.Utf8);
        return result;
    } else {
        return "";
    }
};
//#endregion

//#region Extension Type For Upload file

export const Extension = {
    Image: ["jpg", "jpeg", "png", "gif"],
    Video: ["mov", "wmv", "avi", "mp4"],
    PDF: ["pdf"],
    Document: ["doc", "docx", "xls", "xlsx", "txt"],
    Word: ["doc", "docx"],
    Excel: ["xls", "xlsx"],
    PowerPoint: ["pptx", "ppt"],
    txt: ["txt"],
    Email: ["msg"],
    Other: ["rar", "zip"],
    AllType: null,
    Image_New: ["jpg", "jpeg", "png"],
    Video_New: ["mp4"],

};
//#endregion

export const OptionsStatus = [{ value: true, label: "ใช้งาน", }, { value: false, label: "ไม่ใช้งาน", }];

//#region DropdownDate DropdownMonth DropdownYear
export const OptionsYearMonth = [
    { value: "1", label: "Jan", sName: "January", disabled: false },
    { value: "2", label: "Feb", sName: "February", disabled: false },
    { value: "3", label: "Mar", sName: "March", disabled: false },
    { value: "4", label: "Apr", sName: "April", disabled: false },
    { value: "5", label: "May", sName: "May", disabled: false },
    { value: "6", label: "Jun", sName: "June", disabled: false },
    { value: "7", label: "Jul", sName: "July", disabled: false },
    { value: "8", label: "Aug", sName: "August", disabled: false },
    { value: "9", label: "Sep", sName: "September", disabled: false },
    { value: "10", label: "Oct", sName: "October", disabled: false },
    { value: "11", label: "Nov", sName: "November", disabled: false },
    { value: "12", label: "Dec", sName: "December", disabled: false }
]
export const Option30Date = () => {
    let lstDate = [];
    for (let index = 1; index <= 30; index++) {
        lstDate.push({ label: index + "", value: index + "" })
    }
    return lstDate;
}
export const ConvertToFloatNullable = (value) => {
    let result = 0;
    let value_ = (value + "").replaceAll(",", "");
    result = IsNullOrUndefined(value) ? null : parseFloat(value_);

    return result
}
export const ConvertToStringNullable = (value) => {
    let result = "";
    let value_ = (value + "").replaceAll(",", "");
    result = IsNullOrUndefined(value) ? null : parseFloat(value_).toString();

    return result
}
export const ConvertToIntNullable = (value) => {
    let result = null;
    let value_ = (value + "").replaceAll(",", "");
    result = IsNullOrUndefined(value) ? null : parseInt(value_);

    return result
}
export const GetElementById = (sID) => {

    let el = (document.getElementById(sID) as HTMLInputElement);
    return el;
}

export function DisableFieldMonth(id, isDisable) {
    for (let i = 1; i <= 12; i++) {
        let inputMonth: any = document.getElementById("input_M" + i + "_" + id);
        if (inputMonth) {
            inputMonth.disabled = isDisable;
            if (isDisable) {
                inputMonth.style.backgroundColor = "#E9E8E8";
                inputMonth.classList.add("Mui-disabled");
                let pas = inputMonth.parentNode;
                if (pas) {
                    pas.classList.add("Mui-disabled");
                    pas.disabled = isDisable;
                }
            }
            else {
                inputMonth.style.backgroundColor = "rgba(255,255,255,0.95)";
                inputMonth.classList.remove("Mui-disabled");
                let pas = inputMonth.parentNode;
                if (pas) {
                    pas.classList.remove("Mui-disabled");
                }
            }
        }
    }
}

export function ClearFieldMonth(id) {
    for (let i = 1; i <= 12; i++) {
        let inputMonth = document.getElementById("input_M" + i + "_" + id) as HTMLInputElement;
        if (inputMonth) {
            inputMonth.value = "";
        }
    }
}

export function DisableButton(id, isDisable) {
    let btn = document.getElementById(id) as HTMLInputElement;
    if (btn) {
        btn.disabled = isDisable;
        if (isDisable) {
            btn.classList.add("Mui-disabled");
        }
        else {
            btn.classList.remove("Mui-disabled");
        }
    }
}

export function DisableInput(id, isDisable) {

    let inputMonth: any = document.getElementById(id);
    if (inputMonth) {
        inputMonth.disabled = isDisable;
        if (isDisable) {
            inputMonth.style.backgroundColor = "#E9E8E8"
            inputMonth.classList.add("Mui-disabled");
            let pas = inputMonth.parentNode;
            if (pas) {
                pas.classList.add("Mui-disabled");
                pas.disabled = isDisable;
            }
        }
        else {
            inputMonth.style.backgroundColor = "rgba(255,255,255,0.95)"
            inputMonth.classList.remove("Mui-disabled");
            let pas = inputMonth.parentNode;
            if (pas) {
                pas.classList.remove("Mui-disabled");
            }
        }
    }
}

export function SetInputValue(id, value) {
    let _input = document.getElementById(id) as HTMLInputElement;
    if (_input) {
        _input.value = value;
    }
}
export const GetQueryString = (Value) => {
    const location = useLocation();
    const searchParams = location.search;
    let Result = "";
    if (Value) {
        Result = new URLSearchParams(searchParams).get(Value) as string;
        Result = (!IsNullOrUndefined(Result)) ? Result.replace(/\+/gi, '%2B') : "";//ดักกรณีเป็นค่าว่าง
    }
    return Result;
};

export const SetRequireInputNoForm = (item, nMonth, isRequire) => {
    if (item) {
        if (item["ref" + nMonth] && item["ref" + nMonth].current) {
            item["ref" + nMonth].current.onRequire(isRequire);
        }
    }
}

export const OnSetRequireInputAllMonth = (lstMonthSubmit, item) => {
    for (let i = 1; i <= 12; i++) {
        if (item.isRequire) {
            let isMonthSubmit = (item.lstMonthSubmit || []).indexOf(i) > -1;
            let isValueEmpty = IsNullOrUndefined(item["sM" + i]);
            let isRequire = isMonthSubmit && isValueEmpty;
            SetRequireInputNoForm(item, i, isRequire);
        }
    }
}

export const OnSetRequireInputByMonth = (item, nMonth) => {
    if (item.isRequire) {
        let isMonthSubmit = (item.lstMonthSubmit || []).indexOf(nMonth) > -1;
        let isValueEmpty = IsNullOrUndefined(item["sM" + nMonth]);
        let isRequire = isMonthSubmit && isValueEmpty;
        SetRequireInputNoForm(item, nMonth, isRequire);
    }
}

export const OnSetRequireInputYear = (lstMonthSubmit, item, InputMode) => {
    if (item.isRequire) {
        let isMonthSubmit = (item.lstMonthSubmit).indexOf(12) > -1;
        let isValueEmpty = IsNullOrUndefined(item["sM" + InputMode]);
        let isRequire = isMonthSubmit && isValueEmpty;
        SetRequireInputNoForm(item, 12, isRequire);
    }
}

export const OnSetRequireInput = (item, id) => {

    if (item.isRequire) {
        let oData = GetElementById(id);

        if (oData != null) {

            let isValueEmpty = IsNullOrUndefined(oData.value);
            let isRequire = isValueEmpty;
            SetRequireInputNoForm(item, id, isRequire);
        }

    }

}